<div class="container-fluid">
  <div class="row">
    <div class="body-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<div class="bot-logo">Designed and developed by Tapko Wild &#64; Raiden.</div>
